<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Medical Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="page-header-box">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="page-icon">
                      <i class="mdi mdi-receipt-text-check-outline"></i>
                    </div>
                    <div class="ms-3">
                      <h4 class="page-title mb-1">Paid Bills</h4>
                      <p class="page-breadcrumb mb-0">
                        <span>Dashboard</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Medical Certificates</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Paid Bills</span>
                      </p>
                    </div>
                  </div>
                  <div class="header-stats-row d-flex">
                    <div class="header-stat-box">
                      <span class="stat-number">{{ numberFormat(summary.count) }}</span>
                      <span class="stat-text">PAID BILLS</span>
                    </div>
                    <div class="header-stat-box stat-success">
                      <span class="stat-number">KES {{ numberFormat(summary.total) }}</span>
                      <span class="stat-text">TOTAL COLLECTED</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarMedical/>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <!-- Card Header -->
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                      <h5 class="card-title mb-1">
                        <i class="mdi mdi-check-decagram-outline me-2 text-success"></i>
                        All Paid Bills
                      </h5>
                      <p class="text-muted mb-0 small">Medical certificate bills that have been fully paid</p>
                    </div>
                    <div class="d-flex gap-2">
                      <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')" class="btn btn-primary">
                        <i class="mdi mdi-plus-circle-outline me-1"></i> Create Bill
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Filters Section -->
                <div class="card-header bg-white border-bottom">
                  <div class="row g-3 align-items-end">
                    <div class="col-md-3">
                      <label class="form-label text-muted small text-uppercase fw-semibold mb-2">Search</label>
                      <div class="header-search-box">
                        <div class="position-relative">
                          <i class="mdi mdi-magnify search-icon"></i>
                          <input
                              v-model="search"
                              type="text"
                              class="form-control search-input"
                              placeholder="Search bills..."
                          >
                          <button v-if="search" @click="search = ''" class="btn-clear">
                            <i class="mdi mdi-close"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label text-muted small text-uppercase fw-semibold mb-2">Filter by Date</label>
                      <div class="d-flex align-items-center gap-2">
                        <input class="form-control" type="date" v-model="dateFrom" placeholder="From">
                        <span class="text-muted">to</span>
                        <input class="form-control" type="date" v-model="dateTo" placeholder="To">
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label text-muted small text-uppercase fw-semibold mb-2">Filter By</label>
                      <div class="d-flex gap-2">
                        <select class="form-select" v-model="filter">
                          <option value="filter-all">All Transactions</option>
                          <option value="filter-sub-county">By Sub County</option>
                          <option value="filter-wards">By Ward</option>
                          <option value="filer-zone">By Zone</option>
                          <option value="filter-officer">By Officer</option>
                        </select>
                        <select v-if="itemList.length > 0" class="form-select" v-model="selectedItem">
                          <option v-for="(item, index) in itemList" :key="index" :value="item.value">
                            {{ item.value }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2 text-end">
                      <div class="revenue-summary">
                        <span class="text-muted small d-block">Collected Revenue</span>
                        <span class="fw-bold text-success">KES {{ numberFormat(summary.total) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="card-body p-0">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading records...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-if="billDetails.length < 1 && loading === false" class="text-center py-5">
                    <img src="assets/images/no-results.png" class="mb-4" style="height: 120px;" alt="No results"/>
                    <h5>No Paid Bills Found</h5>
                    <p class="text-muted">No paid bills found matching your search or filter criteria.</p>
                    <button v-if="search" @click="search = ''" class="btn btn-outline-primary btn-sm">
                      <i class="mdi mdi-refresh me-1"></i> Clear Search
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-if="billDetails.length > 0 && !loading" class="table-responsive">
                    <table class="table table-hover table-striped mb-0">
                      <thead class="table-light">
                      <tr>
                        <th>#</th>
                        <th>BILL NO</th>
                        <th>APPLICANT</th>
                        <th>DESCRIPTION</th>
                        <th>LOCATION</th>
                        <th>ATTENDANT</th>
                        <th>BILLED</th>
                        <th>PAID</th>
                        <th>BALANCE</th>
                        <th>STATUS</th>
                        <th>DATE</th>
                        <th class="text-end">ACTIONS</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in billDetails" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <span class="fw-medium text-primary font-monospace">{{ item.billNo }}</span>
                        </td>
                        <td>
                          <span v-if="item.customers && item.customers.includes('Applicant ID:')" class="badge bg-success">
                            <i class="mdi mdi-account-check me-1"></i>
                            {{ item.customers }}
                          </span>
                          <span v-else class="badge bg-warning text-dark">
                            <i class="mdi mdi-account-alert me-1"></i>
                            Not Linked
                          </span>
                        </td>
                        <td>
                            <span class="text-truncate d-inline-block" style="max-width: 200px;">
                              {{ item.feeDescription }}
                            </span>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.subCountyName }}</span>
                            <br>
                            <small class="text-muted">{{ item.wardName }}</small>
                          </div>
                        </td>
                        <td>{{ item.names }}</td>
                        <td>
                          <span class="fw-medium">{{ formatPrice(item.detailAmount) }}</span>
                        </td>
                        <td>
                          <span class="fw-medium text-success">{{ formatPrice(item.receiptAmount) }}</span>
                        </td>
                        <td>
                            <span class="fw-medium" :class="item.billBalance > 0 ? 'text-danger' : 'text-success'">
                              {{ formatPrice(item.billBalance) }}
                            </span>
                        </td>
                        <td>
                            <span class="badge bg-success" v-if="item.status === 'PAID'">
                              <i class="mdi mdi-check-circle-outline me-1"></i>
                              PAID
                            </span>
                          <span class="badge bg-warning text-dark" v-else>
                              UNPAID
                            </span>
                        </td>
                        <td>
                          <small>{{ item.dateCreated }}</small>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end gap-2">
                            <button
                                @click="getBill(item.billNo)"
                                class="btn btn-sm btn-primary"
                                data-target="#billDetail"
                                data-toggle="modal"
                                title="View Details"
                            >
                              <i class="mdi mdi-eye-outline me-1"></i> View
                            </button>
                            <div class="dropdown">
                              <button class="btn btn-sm btn-light" data-bs-toggle="dropdown">
                                <i class="mdi mdi-dots-vertical"></i>
                              </button>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a class="dropdown-item" @click="printBillDirect(item.billNo)">
                                  <i class="mdi mdi-printer-outline me-2"></i> Print
                                </a>
                                <a class="dropdown-item" href="javascript: void(0);">
                                  <i class="mdi mdi-email-outline me-2"></i> Send Email
                                </a>
                                <a class="dropdown-item" href="javascript: void(0);">
                                  <i class="mdi mdi-message-text-outline me-2"></i> Send SMS
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-light">
                      <tr class="fw-bold">
                        <td colspan="6">{{ billDetails.length }} Bills</td>
                        <td>{{ totalDetailAmount }}</td>
                        <td class="text-success">{{ totalReceiptAmount }}</td>
                        <td>{{ totalBillBalance }}</td>
                        <td colspan="3"></td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="!loading && billDetails.length > 0" class="card-footer bg-white border-top d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                      <span class="text-muted small">Rows per page:</span>
                      <select class="form-select form-select-sm w-auto" v-model="pageSize">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                      </select>
                    </div>
                    <nav>
                      <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" @click="prevPage">Previous</a>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" @click="nextPage">Next</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Bill Details Modal -->
      <div class="modal fade" id="billDetail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header modal-header-white">
              <div class="d-flex align-items-center">
                <div class="modal-header-icon icon-success">
                  <i class="mdi mdi-receipt-text-check-outline"></i>
                </div>
                <div class="ms-3">
                  <h5 class="modal-title mb-0">Bill Details</h5>
                  <small class="text-muted font-monospace">{{ billNo }}</small>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="badge bg-success me-3">Paid</span>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
              </div>
            </div>

            <div class="modal-body">
              <!-- Bill Info -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-information-outline me-2"></i>
                  Bill Information
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">DESCRIPTION</label>
                    <p class="mb-0 fw-medium">{{ billDetail.feeDescription || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">DATE CREATED</label>
                    <p class="mb-0 fw-medium">{{ billDetail.dateCreated || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">AMOUNT</label>
                    <p class="mb-0 fw-medium text-success">KES {{ numberFormat(billDetail.detailAmount) }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">CURRENT APPLICANT</label>
                    <p class="mb-0">
                      <span v-if="billDetail.customers && billDetail.customers.includes('Applicant ID:')" class="badge bg-success">
                        {{ billDetail.customers }}
                      </span>
                      <span v-else class="badge bg-warning text-dark">Not Linked to Applicant</span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- Success Messages -->
              <div v-if="applicantLinkedSuccess && !certificateProcessed" class="alert alert-success mb-4">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-check-circle font-24 me-3"></i>
                  <div>
                    <h6 class="alert-heading mb-1">Applicant Linked Successfully!</h6>
                    <p class="mb-0">{{ individualDetails.names }} (ID: {{ individualDetails.idNo }}) has been linked to this bill. You can now process the medical certificate.</p>
                  </div>
                </div>
              </div>

              <div v-if="certificateProcessed" class="alert alert-success mb-4">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-check-decagram font-36 me-3 text-success"></i>
                  <div>
                    <h5 class="alert-heading mb-1 text-success">Certificate Processed Successfully!</h5>
                    <p class="mb-0">The medical certificate has been generated and is now <strong>pending approval</strong>.</p>
                    <p class="mb-0 mt-2 small text-muted">You can close this window now.</p>
                  </div>
                </div>
              </div>

              <!-- Link to Applicant Section - Only show if not already linked -->
              <div v-if="!billDetail.customers || !billDetail.customers.includes('Applicant ID:')" class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-account-search-outline me-2"></i>
                  Link to Applicant
                </h6>

                <!-- Search Method Selection -->
                <div class="row mb-3">
                  <div class="col-12">
                    <label class="form-label">Search or Register Applicant</label>
                    <select v-model="selectedMethod" class="form-select">
                      <option value="">Select Method</option>
                      <option value="search">Search Existing Applicant by ID Number</option>
                      <option value="register">Register New Applicant</option>
                    </select>
                  </div>
                </div>

                <!-- Search Existing Applicant -->
                <div v-if="selectedMethod === 'search'" class="search-applicant-section">
                  <div class="input-group mb-3">
                    <input
                        v-model="searchIdNo"
                        type="text"
                        class="form-control"
                        placeholder="Enter ID Number to search..."
                        @keyup.enter="searchIndividual()"
                    >
                    <button @click="searchIndividual()" class="btn btn-primary" type="button" :disabled="individualSearching">
                      <i v-if="individualSearching" class="bx bx-loader bx-spin"></i>
                      <i v-else class="mdi mdi-magnify"></i>
                      Search
                    </button>
                  </div>

                  <!-- Search Results -->
                  <div v-if="individualFound" class="alert alert-success">
                    <h6 class="alert-heading mb-2">
                      <i class="mdi mdi-account-check me-2"></i>Applicant Found
                    </h6>
                    <table class="table table-sm table-borderless mb-0">
                      <tr>
                        <th width="150">Full Names:</th>
                        <td>{{ individualDetails.names }}</td>
                      </tr>
                      <tr>
                        <th>ID Number:</th>
                        <td>{{ individualDetails.idNo }}</td>
                      </tr>
                      <tr>
                        <th>Phone Number:</th>
                        <td>{{ individualDetails.phoneNumber }}</td>
                      </tr>
                      <tr>
                        <th>Email:</th>
                        <td>{{ individualDetails.email }}</td>
                      </tr>
                      <tr>
                        <th>Location:</th>
                        <td>{{ individualDetails.subCountyName }}, {{ individualDetails.wardName }}</td>
                      </tr>
                    </table>
                  </div>

                  <!-- No Results -->
                  <div v-if="noResultsFound" class="alert alert-warning">
                    <i class="mdi mdi-alert-circle me-2"></i>
                    No applicant found with ID Number: <strong>{{ searchIdNo }}</strong>
                    <br>
                    <small>You can register a new applicant using the dropdown above.</small>
                  </div>
                </div>

                <!-- Register New Applicant -->
                <div v-if="selectedMethod === 'register'" class="register-applicant-section">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Full Names <span class="text-danger">*</span></label>
                      <input v-model="individualDetails.names" type="text" class="form-control" placeholder="Enter Full Names">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">ID Number <span class="text-danger">*</span></label>
                      <input v-model="individualDetails.idNo" type="text" class="form-control" placeholder="Enter ID Number">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                      <input v-model="individualDetails.phoneNumber" type="text" class="form-control" placeholder="e.g. 0712345678">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Email Address <span class="text-danger">*</span></label>
                      <input v-model="individualDetails.email" type="email" class="form-control" placeholder="email@example.com">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Sub County <span class="text-danger">*</span></label>
                      <select class="form-select" v-model="subCounty">
                        <option value="">Select Sub County</option>
                        <option v-for="(item, index) in subCounties" :value="item" :key="index">
                          {{ item.subCountyName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Ward <span class="text-danger">*</span></label>
                      <select class="form-select" v-model="ward">
                        <option value="">Select Ward</option>
                        <option v-for="(item, index) in wards" :value="item" :key="index">
                          {{ item.wardName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Job Title/Occupation</label>
                      <input v-model="individualDetails.jobTitle" type="text" class="form-control" placeholder="e.g. Food Handler, Chef">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Employer/Business Name</label>
                      <input v-model="individualDetails.employer" type="text" class="form-control" placeholder="Name of Employer or Business">
                    </div>
                  </div>

                  <button @click="registerAndLinkIndividual()" class="btn btn-success w-100" :disabled="registering">
                    <i v-if="registering" class="bx bx-loader bx-spin me-2"></i>
                    <i v-else class="mdi mdi-account-plus me-2"></i>
                    Register & Link to Bill
                  </button>
                </div>

              </div>

              <!-- Already Linked - Show linked applicant info -->
              <div v-else class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-account-check-outline me-2 text-success"></i>
                  Linked Applicant
                </h6>
                <div class="alert alert-success mb-0">
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-check-circle font-24 me-3"></i>
                    <div>
                      <p class="mb-1"><strong>{{ billDetail.customers }}</strong></p>
                      <p class="mb-0 small" v-if="billDetail.customerName">Name: {{ billDetail.customerName }}</p>
                      <p class="mb-0 small" v-if="billDetail.customerPhoneNumber">Phone: {{ billDetail.customerPhoneNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer bg-light">
              <!-- After certificate processed - show only Close button -->
              <div v-if="certificateProcessed" class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center text-success">
                  <i class="mdi mdi-check-circle font-24 me-2"></i>
                  <span class="fw-medium">Certificate processed successfully!</span>
                </div>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="closeModal()">
                  <i class="mdi mdi-close me-1"></i> Close
                </button>
              </div>

              <!-- Normal state - show all buttons -->
              <div v-else class="d-flex gap-2 w-100 justify-content-end">
                <button type="button" class="btn btn-light" data-dismiss="modal" @click="closeModal()">
                  <i class="mdi mdi-close me-1"></i> Close
                </button>
                <button
                    v-if="individualFound && selectedMethod === 'search' && !applicantLinkedSuccess"
                    @click="linkApplicantToBill()"
                    class="btn btn-warning"
                    :disabled="linking"
                >
                  <i v-if="linking" class="bx bx-loader bx-spin me-2"></i>
                  <i v-else class="mdi mdi-link-variant me-1"></i>
                  Link Applicant to Bill
                </button>
                <button
                    v-if="applicantLinkedSuccess || (billDetail.customers && billDetail.customers.includes('Applicant ID:'))"
                    @click="processCertificate()"
                    class="btn btn-success"
                    :disabled="processingCertificate"
                >
                  <i v-if="processingCertificate" class="bx bx-loader bx-spin me-2"></i>
                  <i v-else class="mdi mdi-certificate me-1"></i>
                  Process Certificate
                </button>
                <button @click="printBill()" class="btn btn-primary">
                  <i class="mdi mdi-printer-outline me-1"></i> Print Bill
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, health, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import ToolBarMedical from "@/components/medical/ToolBarMedical.vue";

export default {
  name: "MedicalPaidBills",
  components: { ToolBarMedical, NavigationBar },

  data() {
    return {
      // Search/Filter
      search: '',
      searchTimeout: null,
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },
      totalAmount: null,
      selectedItem: null,
      valueItem: "",
      itemList: [],
      filter: 'filter-all',
      dateFrom: '',
      dateTo: '',
      message: '',

      // Bills Data
      billDetails: [],
      billInfo: [],
      receiptInfos: [],
      billDetail: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        status: null,
        dateCreated: null,
        description: null,
        customers: null
      },
      billInfoTotal: 0,
      billNo: '',

      // Applicant Linking
      selectedMethod: '',
      searchIdNo: '',
      individualSearching: false,
      individualFound: false,
      noResultsFound: false,
      registering: false,
      linking: false,
      applicantLinkedSuccess: false,

      // Certificate Processing
      processingCertificate: false,
      certificateProcessed: false,

      // Individual Details
      individualDetails: {
        id: null,
        idNo: '',
        names: '',
        phoneNumber: '',
        email: '',
        subCountyID: '',
        subCountyName: '',
        wardID: '',
        wardName: '',
        jobTitle: '',
        employer: ''
      },

      // Location data
      subCounty: {},
      ward: {},
      subCounties: [],
      wards: []
    }
  },

  watch: {
    pageSize(newPageSize) {
      this.currentPage = 1;
      this.getBills();
    },
    search(newVal) {
      // Debounce search to avoid too many API calls
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.getBills();
      }, 400);
    },
    subCounty: function () {
      if (this.subCounty && this.subCounty.subCountyID) {
        this.individualDetails.subCountyName = this.subCounty.subCountyName;
        this.individualDetails.subCountyID = this.subCounty.subCountyID;
        this.getWardsForRegistration();
      }
    },
    ward: function () {
      if (this.ward && this.ward.wardID) {
        this.individualDetails.wardName = this.ward.wardName;
        this.individualDetails.wardID = this.ward.wardID;
      }
    }
  },

  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount || 0), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance || 0), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount || 0), 0));
    }
  },

  mounted() {
    this.menuAccess();
    this.getBills();
    this.getSubCounties();

    this.$watch('selectedItem', function (newValue) {
      this.currentPage = 1;
      this.getBills();
    });

    this.$watch('dateFrom', function () {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1;
        this.getBills();
      }
    });

    this.$watch('dateTo', function () {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1;
        this.getBills();
      }
    });

    this.$watch('filter', function (newValue) {
      if (newValue === 'filter-all') this.getBills();
      if (newValue === 'filter-sub-county') this.getSubCountiesFilter();
      if (newValue === 'filter-wards') this.getWardsFilter();
      if (newValue === 'filer-zone') this.getZones();
      if (newValue === 'filter-officer') this.getUsers();
    });
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Medical Paid Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error(e));
    },

    getRight(type) {
      return getRight(type);
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBills();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBills();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBills();
      }
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value || 0);
    },

    gotTo(route) {
      router.push(route);
    },

    // Reset modal state
    resetModalState() {
      this.selectedMethod = '';
      this.searchIdNo = '';
      this.individualFound = false;
      this.noResultsFound = false;
      this.applicantLinkedSuccess = false;
      this.processingCertificate = false;
      this.certificateProcessed = false;
      this.individualDetails = {
        id: null,
        idNo: '',
        names: '',
        phoneNumber: '',
        email: '',
        subCountyID: '',
        subCountyName: '',
        wardID: '',
        wardName: '',
        jobTitle: '',
        employer: ''
      };
      this.subCounty = {};
      this.ward = {};
    },

    // ==================== Bills Methods ====================

    getBills() {
      this.billDetails = [];
      this.loading = true;

      const data = new FormData();
      data.append("function", "getBillsPaginate");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("incomeTypePrefix", "PUBLIC-HEALTH-MEDICAL");

      // Send the actual search keyword when user is searching
      if (this.search && this.search.trim() !== '') {
        data.append("keyword", this.search.trim());
      }

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            this.summary = { count: 0, total: 0 };
            this.totalAmount = null;

            if (res.data.success) {
              this.billDetails = res.data.data.billDetails || [];
              this.summary = res.data.data.summary || { count: 0, total: 0 };
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);

              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                const receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
          });
    },

    getBill(billNo) {
      this.billNo = billNo;
      this.resetModalState();

      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billInfo = res.data.data.billInfo;
              this.billDetail = res.data.data.billDetails;
            }
          })
          .catch((e) => console.error(e));
    },

    // ==================== Individual/Applicant Methods ====================

    searchIndividual() {
      if (!this.searchIdNo) {
        alert("Please enter an ID number to search");
        return;
      }

      this.individualSearching = true;
      this.individualFound = false;
      this.noResultsFound = false;

      const data = new FormData();
      data.append("function", "getIndividual");
      data.append("idNo", this.searchIdNo);

      execute(data, health)
          .then((res) => {
            this.individualSearching = false;
            if (res.data.success) {
              this.individualFound = true;
              const individual = res.data.data.individual;

              // Map API response to component fields
              this.individualDetails = {
                id: individual.id,
                idNo: individual.individualD || individual.idNo || '',
                names: individual.individualNames || individual.names || '',
                phoneNumber: individual.phoneNumber || '',
                email: individual.email || '',
                subCountyID: individual.subCountyID || '',
                subCountyName: individual.subCountyName || '',
                wardID: individual.wardID || '',
                wardName: individual.wardName || '',
                jobTitle: individual.jobTitle || '',
                employer: individual.employer || ''
              };
            } else {
              this.noResultsFound = true;
            }
          })
          .catch((e) => {
            this.individualSearching = false;
            this.noResultsFound = true;
            console.error(e);
          });
    },

    registerAndLinkIndividual() {
      // Validate required fields
      if (!this.individualDetails.names || !this.individualDetails.idNo ||
          !this.individualDetails.phoneNumber || !this.individualDetails.email ||
          !this.individualDetails.subCountyID || !this.individualDetails.wardID) {
        alert("Please fill in all required fields");
        return;
      }

      this.registering = true;

      const data = new FormData();
      data.append("function", "addIndividual");
      data.append("individual", JSON.stringify(this.individualDetails));

      execute(data, health)
          .then((res) => {
            this.registering = false;
            if (res.data.success) {
              // Now link to the bill
              this.linkApplicantToBill();
            } else {
              alert(res.data.message || "Failed to register applicant");
            }
          })
          .catch((e) => {
            this.registering = false;
            alert(e.message);
          });
    },

    linkApplicantToBill() {
      if (!this.individualDetails.idNo) {
        alert("No applicant selected");
        return;
      }

      this.linking = true;

      const data = new FormData();
      data.append("function", "linkApplicantToBill");
      data.append("billNo", this.billNo);
      data.append("idNo", this.individualDetails.idNo);
      data.append("customerName", this.individualDetails.names);
      data.append("customerPhoneNumber", this.individualDetails.phoneNumber);

      execute(data, health)
          .then((res) => {
            this.linking = false;
            if (res.data.success) {
              this.applicantLinkedSuccess = true;
              // Update local bill detail to reflect the change
              this.billDetail.customers = `Applicant ID: ${this.individualDetails.idNo}`;
              this.billDetail.customerName = this.individualDetails.names;
              this.billDetail.customerPhoneNumber = this.individualDetails.phoneNumber;
              // Refresh the bills list
              this.getBills();
              // Success message shown in UI - no alert needed
            } else {
              alert(res.data.message || "Failed to link applicant to bill");
            }
          })
          .catch((e) => {
            this.linking = false;
            alert(e.message);
          });
    },

    processCertificate() {
      if (!this.billNo) {
        alert("No bill selected");
        return;
      }

      this.processingCertificate = true;

      const data = new FormData();
      data.append("function", "updateServiceRecordsForBill");
      data.append("billNo", this.billNo);

      execute(data, biller)
          .then((res) => {
            this.processingCertificate = false;
            if (res.data.success) {
              this.certificateProcessed = true;
              // Refresh the bills list
              this.getBills();
              // Success message shown in UI - no alert needed
            } else {
              alert(res.data.message || "Failed to process certificate");
            }
          })
          .catch((e) => {
            this.processingCertificate = false;
            alert(e.message);
          });
    },

    closeModal() {
      // Try jQuery method (Bootstrap 4)
      if (typeof $ !== 'undefined') {
        $('#billDetail').modal('hide');
      }
      // Try Bootstrap 5 method
      const modal = document.getElementById('billDetail');
      if (modal) {
        // Remove modal backdrop manually if needed
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        modal.classList.remove('show');
        modal.style.display = 'none';
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    },

    // ==================== Location Methods ====================

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => console.error(e));
    },

    getWardsForRegistration() {
      this.wards = [];
      this.ward = '';

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCounty.subCountyID);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            }
          })
          .catch((e) => console.error(e));
    },

    // ==================== Filter Methods ====================

    getSubCountiesFilter() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getSubCounty");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.itemList = res.data.data.subCounties.map(sc => ({
                id: sc.subCountyID,
                value: sc.subCountyName
              }));
            }
          })
          .catch((e) => console.error(e));
    },

    getWardsFilter() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getWards");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.itemList = res.data.data.wards.map(w => ({
                id: w.wardID,
                value: w.wardName
              }));
            }
          })
          .catch((e) => console.error(e));
    },

    getZones() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getZones");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.itemList = res.data.data.zones.map(z => ({
                id: z.id,
                value: z.zone
              }));
            }
          })
          .catch((e) => console.error(e));
    },

    getUsers() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getUsers");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.itemList = res.data.data.users.map(u => ({
                id: u.id,
                value: u.names
              }));
            }
          })
          .catch((e) => console.error(e));
    },

    // ==================== Print Methods ====================

    printBill() {
      localStorage['params'] = JSON.stringify({ billNo: this.billDetail.billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printBillDirect(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.page-icon {
  width: 50px;
  height: 50px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #2a3f54;
}

.page-breadcrumb {
  font-size: 13px;
  color: #6c757d;
}

.page-breadcrumb span:last-child {
  color: #2a3f54;
  font-weight: 500;
}

.header-stats-row {
  gap: 12px;
}

.header-stat-box {
  background: #2a3f54;
  border-radius: 8px;
  padding: 12px 20px;
  text-align: center;
  min-width: 140px;
}

.header-stat-box.stat-success {
  background: #28a745;
}

.stat-number {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.stat-text {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Search Box */
.header-search-box {
  position: relative;
}

.header-search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 18px;
}

.header-search-box .search-input {
  padding-left: 40px;
  padding-right: 36px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  height: 40px;
}

.header-search-box .search-input:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.1);
}

.header-search-box .btn-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  padding: 4px;
}

.header-search-box .btn-clear:hover {
  color: #495057;
}

/* Table Styling */
.table thead th {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding: 12px 16px;
  white-space: nowrap;
}

.table tbody td {
  padding: 12px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.table tbody tr:hover {
  background: #f8f9fa;
}

.table tfoot td {
  padding: 12px 16px;
  font-weight: 600;
}

/* Revenue Summary */
.revenue-summary {
  background: #f8f9fa;
  padding: 10px 16px;
  border-radius: 6px;
  text-align: right;
}

/* Modal Styling */
.modal-header-white {
  background: #fff;
  color: #2a3f54;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 20px;
}

.modal-header-icon {
  width: 44px;
  height: 44px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.modal-header-icon.icon-success {
  background: #28a745;
}

/* Section Blocks */
.section-block {
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}

.section-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #2a3f54;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #2a3f54;
}

/* Pagination */
.pagination .page-link {
  color: #2a3f54;
  border-color: #e9ecef;
}

.pagination .page-item.active .page-link {
  background-color: #2a3f54;
  border-color: #2a3f54;
}

.pagination .page-item.disabled .page-link {
  color: #adb5bd;
}

/* Card Footer */
.card-footer {
  padding: 12px 16px;
  font-size: 13px;
}

/* Applicant Search/Register Sections */
.search-applicant-section,
.register-applicant-section {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-top: 12px;
}

/* Responsive */
@media (max-width: 992px) {
  .header-stats-row {
    width: 100%;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

@media (max-width: 768px) {
  .page-header-box {
    padding: 16px;
  }

  .page-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .page-title {
    font-size: 16px;
  }

  .header-stat-box {
    padding: 10px 16px;
    min-width: 120px;
  }

  .stat-number {
    font-size: 16px;
  }
}
</style>